export function dispatchGtmEvent(event, data) {
    window.dataLayer.push(Object.assign(Object.assign({}, data), { event }));
}
export function initGTMTracking() {
    window.dataLayer || (window.dataLayer = []);
    document.documentElement.addEventListener('click', event => {
        const target = event.target;
        const anchorEl = typeof target.closest === 'function' && target.closest('a');
        if (!anchorEl) {
            return;
        }
        // Add generic tracking for specific link types
        if (anchorEl.href.startsWith('tel:')) {
            dispatchGtmEvent('CT.PhoneNumber.click', {
                phone: anchorEl.href.replace('tel:', ''),
                label: anchorEl.dataset.telName || anchorEl.innerText,
            });
        }
        else if (anchorEl.href.startsWith('mailto:')) {
            dispatchGtmEvent('CT.Email.click', {
                email: anchorEl.href.replace('mailto:', ''),
                label: anchorEl.dataset.mailtoName || anchorEl.innerText,
            });
        }
        else if (anchorEl.hasAttribute('data-downloadable') || anchorEl.href.match(/\.(txt|rtf|pdf|docx?)$/)) {
            dispatchGtmEvent('CT.Download.click', {
                fileUrl: anchorEl.href,
                label: anchorEl.dataset.fileName || anchorEl.innerText,
            });
        }
    });
}
